import React, { useEffect, useRef } from "react";

// SASS
import "./Part7.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import asteriskImg from "../../assets/img/asterisk.svg";

export default function Part7({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "spacer" },
    { stepNumber: "2", height: null, description: "spacer" },
  ];

  // REFS
  const animate1Ref = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "0": {
            animate.addClassOnEnter(animate1Ref.current, "show", direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "0": {
            animate.removeClassOnExit(animate1Ref.current, "show", direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part7">
          <div className="part7__box modal" ref={animate1Ref}>
            <div className="part7__heading">
              <span className="pulse">
                <img src={asteriskImg} alt="" className="img-fluid" />
              </span>
              <p>FOR EXAMPLE</p>
            </div>
            <div className="part7__content">
              <p>
                When you cry, your nose may run because some of the tears travel
                into the tear ducts and then drain into your nose and down your
                throat.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
